import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/CustomerUser";

export const ResetPassword = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ResetPassword`, options);

export default {
  ResetPassword,
};
